// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_fragment_forSaleProperties(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
              "ChapterDefaultNotificationSetting",
              "CustomPropertyNotificationPreference",
              "MatchesOnlyNotificationSetting"
            ]);
}

var fragmentConverter = {"__root":{"forSaleProperties_CustomPropertyNotificationPreference_areaGroup":{"f":""},"forSaleProperties_CustomPropertyNotificationPreference":{"f":""},"forSaleProperties":{"u":"fragment_forSaleProperties"},"":{"f":""}}};

var fragmentConverterMap = {
  fragment_forSaleProperties: unwrap_fragment_forSaleProperties
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function forSalePropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "MULTI_UNIT" || $$enum === "LOT" || $$enum === "CONDO" || $$enum === "SINGLE_FAMILY") {
    return $$enum;
  }
  
}

function forSalePropertyTypeEnumV5_fromString(str) {
  return forSalePropertyTypeEnumV5_decode(str);
}

function propertyNotificationPreferenceMLSStatus_decode($$enum) {
  if ($$enum === "ANY" || $$enum === "NOT_ACTIVE_ON_MLS") {
    return $$enum;
  }
  
}

function propertyNotificationPreferenceMLSStatus_fromString(str) {
  return propertyNotificationPreferenceMLSStatus_decode(str);
}

var Utils = {
  forSalePropertyTypeEnumV5_decode: forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: forSalePropertyTypeEnumV5_fromString,
  propertyNotificationPreferenceMLSStatus_decode: propertyNotificationPreferenceMLSStatus_decode,
  propertyNotificationPreferenceMLSStatus_fromString: propertyNotificationPreferenceMLSStatus_fromString
};

var node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = [
  {
    "kind": "RequiredField",
    "field": {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userHasInactiveCustomPreference",
      "storageKey": null
    },
    "action": "THROW"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationSettingsForSaleProperties_notificationSetting",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationSettingsPreferenceEditDialog_settings"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "forSaleProperties",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": (v1/*: any*/),
          "type": "ChapterDefaultNotificationSetting",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v1/*: any*/),
          "type": "MatchesOnlyNotificationSetting",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxPrice",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minPrice",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mlsStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "propertyTypes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "areaGroup",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NotificationSettingsComponents_group"
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NotificationSettingsPreferenceEditDialog_preference"
            }
          ],
          "type": "CustomPropertyNotificationPreference",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserNotificationSettingsV5",
  "abstractKey": null
};
})());

var wrap_fragment_forSaleProperties = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_forSaleProperties = unwrap_fragment_forSaleProperties;
exports.wrap_fragment_forSaleProperties = wrap_fragment_forSaleProperties;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
